export default [
    { id: 1, name: "Árvore" },
    { id: 2, name: "Arbusto" },
    { id: 3, name: "Herbácea" },
    { id: 4, name: "Liana" },
    { id: 5, name: "Trepadeira" },
]